import VanillaTilt from 'vanilla-tilt'

import '@js/app'
import scrollbar from '@js/scrollbar'

import './style.scss'

import '@comp/animate_title/animate_title'
import '@comp/animate_title/animate_title.scss'

import '@comp/banner_intro/banner_intro.scss'
import '@comp/banner_intro/banner_intro'

import '@comp/business_category/business_category.scss'

import scroller from './method_scroller/method_scroller'
import './method_scroller/method_scroller.scss'
import { trackSection } from '@/scripts/ga'

$(() => {
    trackSection('Business')
    scroller()

    VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
        max: 2,
        speed: 600
    })

    scrollbar.init()
})
